// ProfileZone — French. The console's language; the record's own content is French too, but the
// two are separate things. 'not collected', 'Loading…', 'Refresh' and the four tier words live
// in common.fr.ts. The zone has no verb of its own since round 4: the Organisation mast starts
// the research run, and this catalogue only names what the head reads back. The score words and the fetch-date fallback ARE declared below, even though
// other catalogues also carry them: this zone must read French on its own, without depending on
// some unrelated page being in the bundle. The values are byte-identical to the other
// declarations, so the duplicate-key warning in mergeDict never fires.
//
// The raster's own block, cell and value names are declared beside their value in
// `src/shared/raster.v1.ts` and read through `labelFor` — never retyped here.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Profile': 'Profil',
  'one standardised raster of comparable cells': 'une grille unique de cellules comparables',
  '{pct}% of the comparable cells · raster {v}': '{pct}% des cellules comparables · grille {v}',
  'computed nightly · no claim mark': 'calculé chaque nuit · sans marque de revendication',

  // the last research — the one line where the receipt used to be (R4 §4)
  'last research': 'dernière recherche',
  'cells filed': 'cellules déposées',
  'still running': 'en cours',
  'No research run has been started on this organisation yet.':
    'Aucune recherche n’a encore été lancée sur cette organisation.',
  'The run that last worked this raster — its steps, its ledger and every cell it filed':
    'La passe qui a travaillé cette grille en dernier — ses étapes, son journal et chaque cellule déposée',

  // the states
  'The profile did not answer': 'Le profil n’a pas répondu',
  'No cell of the raster is filled for this organisation. "Research" on the masthead starts a run; every value it reads comes back as a proposal with its verbatim quote, and nothing is on the record until you hold it.':
    'Aucune cellule de la grille n’est renseignée pour cette organisation. « Rechercher » dans l’en-tête lance une passe ; chaque valeur lue revient en proposition avec sa citation verbatim, et rien n’est au dossier tant que vous ne l’avez pas retenue.',
  'estimated': 'estimé',
  'The agent inferred this value; it was not read off a page.':
    'L’agent a inféré cette valeur ; elle n’a pas été lue sur une page.',
  'confidence': 'confiance',
  'yes': 'oui',
  'no': 'non',

  // the evidence
  'evidence': 'preuve',
  'hide evidence': 'masquer la preuve',
  'Show the verbatim evidence for this cell': 'Afficher la preuve verbatim de cette cellule',
  'no source ref recorded': 'aucune référence de source enregistrée',
  'The evidence names a source but keeps no verbatim passage.':
    'La preuve nomme une source mais ne conserve aucun passage verbatim.',

  'fit × timing × access': 'adéquation × moment × accès',
  'fit': 'adéquation',
  'timing': 'moment',
  'access': 'accès',
  'not scored': 'non noté',
  'fetch date not recorded': 'date de capture non enregistrée',

  'cells': 'cellules',

  // the head's denominator: how many cells a fill may propose
  'of': 'sur',
  '{n} of the cells a fill may propose are filled; the percentage beside it is measured over the {d} comparable cells.':
    '{n} des cellules qu’une passe peut proposer sont remplies ; le pourcentage à côté se mesure sur les {d} cellules comparables.',
  'Measured over the comparable cells: this server does not report how many a fill may propose.':
    'Mesuré sur les cellules comparables : ce serveur n’indique pas combien une passe peut en proposer.',

  // the kept document behind a citation
  'Open the kept PDF as the run read it': 'Ouvrir le PDF conservé tel que la recherche l’a lu',
  'not found': 'introuvable',
  'A run searched for this cell and found nothing; later runs leave it alone unless asked to refresh.': 'Une passe a cherché cette cellule et n’a rien trouvé ; les passes suivantes la laissent, sauf demande de rafraîchissement.',
}, 'ProfileZone');
